import { get, post } from 'api/http-client';
import localStorage from 'utils/localStorage';
import { getHostName } from 'utils/common';
import jwt from 'utils/jwt';

export const getUser = async () => {
  const token = localStorage.getAuthToken();

  return token ? get('/owners/me') : Promise.reject(Error('NO_TOKEN'));
};

const onSuccessReponse = (resp) => {
  if (resp.token) {
    localStorage.setAuthToken(resp.token);
  } else {
    console.log('no token was found for user');
  }

  return null;
};

export const login = async (username, password) => {
  return post('/owners/auth/login', {
    username,
    password,
    hostname: getHostName(),
  }).then(onSuccessReponse);
};

export const validateHash = async (hash) => {
  return get(`/owners/auth/${getHostName()}/${hash}`);
};

export const forgotPassword = async (username) => {
  return post('/owners/auth/password/forgot', {
    username,
    hostname: getHostName(),
  })
    .then(() => null)
    .catch(() => null);
};

export const resetPassword = async (hash, password) => {
  return post('/owners/auth/password', {
    hash,
    password,
    hostname: getHostName(),
  }).then(onSuccessReponse);
};

export const logout = async () => {
  return post('/owners/me/auth/logout', {}).finally(() => {
    localStorage.removeAuthToken();
    return null;
  });
};

export const saveUserToken = (userToken) =>
  new Promise((resolve, reject) => {
    if (!userToken) {
      reject(Error('Have no token'));
    }

    localStorage.setAuthToken(userToken);
    const tokenFromStorage = localStorage.getAuthToken();

    if (tokenFromStorage) {
      resolve(tokenFromStorage);
    } else {
      reject(Error("USER_TOKEN_STORAGE_KEY wasn't saved"));
    }
  });

export const whoami = () => jwt.decode(localStorage.getAuthToken());
